import styled from '@emotion/styled';
import { DialogOverlay } from '@reach/dialog';
import { Css, Flex, ITheme, Responsive } from '../../../ui';
import { getGradientBackground } from '../../../styles/gradients';
import { Color } from '../../../styles/Color';
import {
	Z_INDEX_OVERLAY_DIALOG_DESKTOP,
	Z_INDEX_OVERLAY_DIALOG_MOBILE,
} from '../../../styles/zIndex';
import Navigation from '../../../components/common/navigation/Navigation';
import Button from '../../../components/common/button/Button';

const StyledDialog = styled(DialogOverlay)``;
export const Dialog = styled(StyledDialog)<{ stickyTop: number }, ITheme>`
	max-width: 100vw;
	width: 100%;
	height: 100dvh;

	display: flex;
	justify-content: center;

	background-color: ${({ theme }) => theme.layout.page.background};
	position: fixed;
	top: ${({ stickyTop }) => Css.pxToRem(stickyTop)};

	&[data-reach-dialog-overlay] {
		z-index: ${Z_INDEX_OVERLAY_DIALOG_DESKTOP};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		&[data-reach-dialog-overlay] {
			z-index: ${Z_INDEX_OVERLAY_DIALOG_MOBILE};
		}
	}
`;

export const Container = styled.div`
	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
`;

export const DialogScroll = styled.div`
	width: 100%;
	flex: 1;
	overflow: auto;
	padding: ${Css.pxToRem(24)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-top: ${Css.pxToRem(16)};
	}
`;

export const DialogContent = styled(Flex)`
	margin: 0 auto;
	width: ${Css.pxToRem(936)};
	max-width: 100%;
	height: 100%;
	min-height: fit-content;
`;

export const SearchWrapper = styled.div`
	width: 100%;
	padding: ${Css.pxToRem(16)};
	padding-bottom: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: 0;
	}
`;

const SEARCH_CONTAINER_HEIGHT = 86;

export const SearchContainer = styled(Flex)<{ searchOffset: number }>`
	width: 100%;
	height: ${({ searchOffset }) =>
		searchOffset
			? Css.pxToRem(searchOffset + SEARCH_CONTAINER_HEIGHT)
			: Css.pxToRem(225)};
	min-height: ${({ searchOffset }) =>
		searchOffset
			? Css.pxToRem(searchOffset + SEARCH_CONTAINER_HEIGHT)
			: Css.pxToRem(225)};
	border-radius: 8px;

	padding: ${Css.pxToRem(24)};
	${getGradientBackground('blue-blue')};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${getGradientBackground('blue-blue-mobile')};
		height: ${Css.pxToRem(100)};
		min-height: unset;
		display: flex;
		justify-content: flex-start;
		left: 0;
		top: 0;
		border-radius: 0 0 32px 32px;
		padding: ${Css.pxToRem(20)} ${Css.pxToRem(24)};
	}
`;

export const StyledNavigation = styled(Navigation)`
	padding-top: 0;
	padding-bottom: 0;
`;

export const SearchInputWrapper = styled(Flex)`
	max-width: ${Css.pxToRem(936)};
	width: 100%;
	color: ${Color.PrimaryWhite};
	gap: ${Css.pxToRem(8)};
	position: relative;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
		align-items: center;
		justify-content: space-between;
	}
`;

export const SearchCloseButton = styled(Button)`
	height: ${Css.pxToRem(59)};
	position: absolute;
	right: 0;
	transform: translateX(calc(100% + ${Css.pxToRem(8)}));

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		position: unset;
		transform: none;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: ${Css.pxToRem(59)};
		justify-content: center;
		gap: 0;
	}
`;

export const CloseButtonLabel = styled.span`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;
